import { render } from "./WalletDrawer.vue?vue&type=template&id=5d99e14a&scoped=true&ts=true"
import script from "./WalletDrawer.vue?vue&type=script&lang=ts"
export * from "./WalletDrawer.vue?vue&type=script&lang=ts"

import "./WalletDrawer.vue?vue&type=style&index=0&id=5d99e14a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d99e14a"]])

export default __exports__